// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__jZ-ew","question":"styles_question__1XZOi","description":"styles_description__puz9P"};